import { HttpInterceptorFn } from '@angular/common/http';

import { environment } from '../../../environments/environment.production';

/** Prefixes relative URLs with `environment.apiUrl` (e.g. `/api` via dev proxy). */
export const apiUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (/^https?:\/\//i.test(req.url)) {
    return next(req);
  }
  const base = environment.apiUrl.replace(/\/$/, '');
  const path = req.url.startsWith('/') ? req.url : `/${req.url}`;
  return next(req.clone({ url: `${base}${path}` }));
};
